/* You Fly LA kit (yk-) v66 :: yk-map.js :: built from kit/src */
/* --- 50-map-0-base.js --- */
/* =====================================================================
   KB5-MAP shared helpers (window.YK_map). Run-once: every file of the map
   group checks its own flag on window.YK_map, so the group can be printed
   by several snippets on one page and still registers once.
   ===================================================================== */
(function () {
  'use strict';
  var M = window.YK_map = window.YK_map || {};
  if (M.base) return;
  M.base = 1;

  M.reduced = function () {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  };
  M.qa = function (s, r) { return Array.prototype.slice.call(r.querySelectorAll(s)); };

  /* x position (viewBox units) of an SVG group placed with a translate(x y) transform */
  M.gx = function (g) {
    try { return g.transform.baseVal.consolidate().matrix.e; } catch (e) { return 0; }
  };

  /* Scroll a pan box so that viewBox x is centred. Only the box scrolls (never the page). */
  M.centre = function (pan, svg, x, smooth) {
    if (!pan || !svg || pan.scrollWidth <= pan.clientWidth + 2) return;
    var vb = svg.viewBox && svg.viewBox.baseVal, w = svg.getBoundingClientRect().width;
    if (!vb || !vb.width || !w) return;
    var max = pan.scrollWidth - pan.clientWidth;
    var left = Math.max(0, Math.min(max, x * (w / vb.width) - pan.clientWidth / 2));
    if (Math.abs(pan.scrollLeft - left) < 2) return;
    if (smooth && !M.reduced() && typeof pan.scrollTo === 'function') pan.scrollTo({ left: left, behavior: 'smooth' });
    else pan.scrollLeft = left;
  };

  /* Mouse drag-to-pan for the pan box (touch and trackpads scroll natively). */
  M.drag = function (pan) {
    if (!pan) return;
    var down = false, moved = false, sx = 0, sl = 0;
    pan.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || pan.scrollWidth <= pan.clientWidth + 2) return;
      down = true; moved = false; sx = e.clientX; sl = pan.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      if (Math.abs(dx) > 4) moved = true;
      if (moved) pan.scrollLeft = sl - dx;
    });
    window.addEventListener('pointerup', function () { down = false; });
    pan.addEventListener('click', function (e) {
      if (moved) { e.stopPropagation(); e.preventDefault(); moved = false; }
    }, true);
  };

  /* Roving tabindex for SVG marks (role=button): one tab stop, arrows move,
     Enter/Space pick. onPick(index, byKeyboard). */
  M.tab = function (items, i) {
    items.forEach(function (g, j) { g.setAttribute('tabindex', j === i ? '0' : '-1'); });
  };
  M.rove = function (items, onPick) {
    items.forEach(function (g, i) {
      g.addEventListener('keydown', function (e) {
        var k = e.key, j = -1;
        if (k === 'Enter' || k === ' ' || k === 'Spacebar') { e.preventDefault(); onPick(i, true); return; }
        if (k === 'ArrowRight' || k === 'ArrowDown') j = Math.min(items.length - 1, i + 1);
        else if (k === 'ArrowLeft' || k === 'ArrowUp') j = Math.max(0, i - 1);
        else if (k === 'Home') j = 0;
        else if (k === 'End') j = items.length - 1;
        if (j < 0) return;
        e.preventDefault();
        onPick(j, true);
        try { items[j].focus({ preventScroll: true }); } catch (err) { items[j].focus(); }
      });
      g.addEventListener('click', function () { onPick(i, false); });
    });
  };

  /* Hold a card stack at the height of its tallest card while something changes the
     cards automatically (Play The Flight), so the page below never jumps on its own.
     User-driven switches are left free (no reserved blank space). Returns hold(on). */
  M.hold = function (box, cards) {
    var on = false, t;
    function measure() {
      box.style.minHeight = '';
      if (!on) return;
      var h = 0;
      cards.forEach(function (c) {
        var was = c.hidden;
        c.hidden = false;
        h = Math.max(h, c.offsetHeight);
        c.hidden = was;
      });
      if (h) box.style.minHeight = h + 'px';
    }
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(measure, 200); }, { passive: true });
    return function (state) {
      if (!box || !cards.length) return;
      on = !!state;
      measure();
    };
  };

  /* Register an element once YK core is there (core and the group load deferred). */
  M.reg = function (name, fn) {
    function go() { if (window.YK && window.YK.reg) window.YK.reg(name, fn); }
    if (window.YK && window.YK.reg) go();
    else document.addEventListener('DOMContentLoaded', go);
  };
})();

/* --- 50-map-1-route.js --- */
/* =====================================================================
   yk-route: Route Explorer. Waypoints (SVG marks + number chips), one plate
   per waypoint, prev/next, HUD, and Play The Flight: the plane flies the
   track from stop to stop (reduced motion: steps through the waypoints with
   no movement). Markup: snippets/yk-route.liquid (complete without JS).
   ===================================================================== */
(function () {
  'use strict';
  var M = window.YK_map = window.YK_map || {};
  if (M.route) return;
  M.route = 1;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function init(el, o) {
    var q = function (s) { return el.querySelector(s); };
    var svg = q('.yk-route__svg'), track = q('.yk-route__track'), plane = q('.yk-route__plane'), pan = q('.yk-route__pan');
    var wps = M.qa('.yk-route__wp', el), chips = M.qa('.yk-route__chip', el), plates = M.qa('.yk-route__plate', el);
    var play = q('.yk-route__play'), prev = q('.yk-route__prev'), next = q('.yk-route__next');
    var hud = q('.yk-route__hud'), hudC = q('.yk-route__count'), hudN = q('.yk-route__now'), ctr = q('.yk-route__ctr');
    if (!svg || !track || !plane || !wps.length || typeof track.getTotalLength !== 'function') return;

    var N = wps.length, total = track.getTotalLength();
    var stops = wps.map(function (w) { return (parseFloat(w.getAttribute('data-f')) || 0) * total; });
    var names = wps.map(function (w) { return w.getAttribute('data-name') || ''; });
    wps.forEach(function (w, j) {
      w.setAttribute('role', 'button');
      w.setAttribute('aria-label', 'Waypoint ' + pad(j + 1) + ': ' + names[j]);
    });
    var xs = wps.map(M.gx);
    var cur = Math.max(0, Math.min(N - 1, parseInt(o.focus, 10) || 0));
    var len = stops[cur], raf = 0, timer = 0, playing = false;
    var hold = M.hold(q('.yk-route__plates'), plates);

    function place(L) {
      L = Math.max(0, Math.min(total, L));
      len = L;
      var p = track.getPointAtLength(L), a = track.getPointAtLength(Math.max(0, L - 1.5)), b = track.getPointAtLength(Math.min(total, L + 1.5));
      var ang = Math.atan2(b.y - a.y, b.x - a.x) * 180 / Math.PI;
      plane.setAttribute('transform', 'translate(' + p.x.toFixed(1) + ' ' + p.y.toFixed(1) + ') rotate(' + ang.toFixed(1) + ')');
      return p;
    }
    function paint(i) {
      wps.forEach(function (w, j) {
        w.classList.toggle('is-on', j === i);
        w.classList.toggle('is-done', j < i);
        w.setAttribute('aria-pressed', j === i ? 'true' : 'false');
      });
      M.tab(wps, i);
      chips.forEach(function (c, j) {
        c.setAttribute('aria-pressed', j === i ? 'true' : 'false');
        c.classList.toggle('is-done', j < i);
      });
      plates.forEach(function (p, j) { p.hidden = j !== i; });
      if (hudC) hudC.textContent = 'Waypoint ' + pad(i + 1) + ' Of ' + N;
      if (hudN) hudN.textContent = names[i];
      if (ctr) ctr.textContent = pad(i + 1) + ' / ' + N;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === N - 1;
    }
    function fly(from, to, done) {
      cancelAnimationFrame(raf);
      var dur = Math.max(900, Math.min(3400, Math.abs(to - from) / total * 16000)), t0 = 0;
      function step(t) {
        if (!t0) t0 = t;
        var k = Math.min(1, (t - t0) / dur), e = k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
        var p = place(from + (to - from) * e);
        if (playing) M.centre(pan, svg, p.x, false);
        if (k < 1) raf = requestAnimationFrame(step);
        else if (done) done();
      }
      raf = requestAnimationFrame(step);
    }
    /* user choice: jump (or fly one leg forward), stop any playback */
    function go(i, animate) {
      i = Math.max(0, Math.min(N - 1, i));
      var from = len, to = stops[i];
      cur = i;
      paint(i);
      if (animate && !M.reduced() && to > from) fly(from, to, null);
      else { cancelAnimationFrame(raf); place(to); }
      M.centre(pan, svg, xs[i], true);
    }
    function setBtn(on) {
      if (!play) return;
      play.setAttribute('aria-pressed', on ? 'true' : 'false');
      var pl = play.querySelector('.yk-route__pl'), pa = play.querySelector('.yk-route__pa');
      if (pl) pl.hidden = on;
      if (pa) pa.hidden = !on;
      if (hud) hud.setAttribute('aria-live', on ? 'off' : 'polite');
    }
    function stop() {
      if (!playing) return;
      playing = false;
      clearTimeout(timer);
      cancelAnimationFrame(raf);
      setBtn(false);
      hold(false);
      el.classList.remove('is-playing');
    }
    function dwell() { if (playing) timer = setTimeout(tick, 1300); }
    function tick() {
      if (!playing) return;
      if (M.reduced()) { /* reduced motion: step, no movement */
        if (cur >= N - 1) { stop(); return; }
        cur += 1; paint(cur); place(stops[cur]); M.centre(pan, svg, xs[cur], false);
        timer = setTimeout(tick, 2600);
        return;
      }
      if (len < stops[cur] - 0.5) { fly(len, stops[cur], dwell); return; } /* resume a paused leg */
      if (cur >= N - 1) { stop(); return; }
      cur += 1;
      paint(cur);
      fly(len, stops[cur], dwell);
    }
    function start() {
      playing = true;
      hold(true);
      setBtn(true);
      el.classList.add('is-playing');
      if (cur >= N - 1 && len >= stops[N - 1] - 0.5) { /* at the end: start over from Van Nuys */
        cur = 0; paint(0); place(stops[0]); M.centre(pan, svg, xs[0], false);
        timer = setTimeout(tick, M.reduced() ? 1600 : 500);
        return;
      }
      if (M.reduced()) { timer = setTimeout(tick, 900); return; }
      tick();
    }

    if (play) play.addEventListener('click', function () { if (playing) stop(); else start(); });
    M.rove(wps, function (i) { stop(); go(i, i === cur + 1); });
    chips.forEach(function (c, i) { c.addEventListener('click', function () { stop(); go(i, i === cur + 1); }); });
    if (prev) prev.addEventListener('click', function () { stop(); go(cur - 1, false); });
    if (next) next.addEventListener('click', function () { stop(); go(cur + 1, true); });
    M.drag(pan);

    paint(cur);
    place(stops[cur]);
    M.centre(pan, svg, xs[cur], false);
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { if (!playing) M.centre(pan, svg, xs[cur], false); }, 180);
    }, { passive: true });
  }

  M.reg('route', init);
})();

/* --- 50-map-2-sectional.js --- */
/* =====================================================================
   yk-sectional: Sectional Mini-Chart. Clickable marks (KVNY, practice area,
   route waypoints) and mark chips open one small card each. Markup:
   snippets/yk-sectional.liquid (complete without JS).
   ===================================================================== */
(function () {
  'use strict';
  var M = window.YK_map = window.YK_map || {};
  if (M.sectional) return;
  M.sectional = 1;

  function init(el, o) {
    var q = function (s) { return el.querySelector(s); };
    var svg = q('.yk-sec__svg'), pan = q('.yk-sec__pan'), strip = q('.yk-sec__chips');
    var chips = M.qa('.yk-sec__chip', el), cards = M.qa('.yk-sec__card', el), all = M.qa('.yk-sec__mk', el);
    if (!svg || !all.length) return;
    /* keyboard order follows the chips: KVNY, practice area, then the route */
    var order = chips.length ? chips.map(function (c) { return c.getAttribute('data-mark'); }) : all.map(function (m) { return m.getAttribute('data-mark'); });
    var marks = order.map(function (id) {
      return all.filter(function (m) { return m.getAttribute('data-mark') === id; })[0];
    }).filter(Boolean);
    var ids = marks.map(function (m) { return m.getAttribute('data-mark'); });
    var cur = Math.max(0, ids.indexOf(o.mark || 'kvny'));
    marks.forEach(function (m) {
      m.setAttribute('role', 'button');
      m.setAttribute('aria-label', m.getAttribute('data-name') || m.getAttribute('data-mark'));
    });

    function chipIntoView(c, smooth) {
      if (!strip || !c || strip.scrollWidth <= strip.clientWidth + 2) return;
      var sr = strip.getBoundingClientRect(), cr = c.getBoundingClientRect();
      var left = strip.scrollLeft + (cr.left - sr.left) - (strip.clientWidth - cr.width) / 2;
      left = Math.max(0, Math.min(strip.scrollWidth - strip.clientWidth, left));
      if (smooth && !M.reduced() && typeof strip.scrollTo === 'function') strip.scrollTo({ left: left, behavior: 'smooth' });
      else strip.scrollLeft = left;
    }
    function show(i, smooth) {
      if (i < 0 || i >= marks.length) return;
      cur = i;
      var id = ids[i];
      marks.forEach(function (m, j) {
        m.classList.toggle('is-on', j === i);
        m.setAttribute('aria-pressed', j === i ? 'true' : 'false');
      });
      M.tab(marks, i);
      var on = null;
      chips.forEach(function (c) {
        var yes = c.getAttribute('data-mark') === id;
        c.setAttribute('aria-pressed', yes ? 'true' : 'false');
        if (yes) on = c;
      });
      cards.forEach(function (c) { c.hidden = c.getAttribute('data-mark') !== id; });
      M.centre(pan, svg, M.gx(marks[i]), smooth);
      chipIntoView(on, smooth);
    }

    M.rove(marks, function (i) { show(i, true); });
    chips.forEach(function (c) {
      c.addEventListener('click', function () { show(ids.indexOf(c.getAttribute('data-mark')), true); });
    });
    M.drag(pan);
    show(cur, false);
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { M.centre(pan, svg, M.gx(marks[cur]), false); }, 180);
    }, { passive: true });
  }

  M.reg('sectional', init);
})();
